/**
 * Where the two Help pages live.
 *
 * Kept in a file of its own, holding nothing else, because the left-hand menu needs these two
 * strings. Importing them from the services would drag the whole of the help and parent response
 * content into the eager bundle, when both pages are lazy loaded.
 */

/** The global Help & FAQ page. */
export const HELP_PAGE_ROUTE = '/help';

/** The Responses to Parents page, under the Help section. */
export const PARENT_RESPONSES_PAGE_ROUTE = '/help/responses';
